import { Button, Input, Modal, Radio } from "antd";
import React from "react";
import Swal from "sweetalert2";

const ModalMensagemPix = ({
  visible,
  setVisible,
  setMessage,
  message,
  sendList,
  handleOk,
  loading,
  pixType,
  setPixType,
  pixTitulo,
  setPixTitulo,
}) => {

  const send = () => {
    if (pixType == undefined || pixType == null || pixType == "") {
      Swal.fire({
        text: "Selecione o tipo da chave PIX.",
        icon: "error",
        timer: 2000,
        showConfirmButton: false,
      });
      return;
    }

    if (message == undefined || message == null || message == "") {
      Swal.fire({
        text: "Selecione o tipo da chave PIX.",
        icon: "error",
        timer: 2000,
        showConfirmButton: false,
      });
      return;
    }

    sendList();
  }

  return (
    <Modal
      centered
      open={visible}
      onCancel={() => handleOk()}
      footer={[
        <Button key="back" onClick={() => handleOk()}>
          Cancelar
        </Button>,
        <Button key="submit" type="primary" loading={loading} onClick={send}>
          Enviar
        </Button>,
      ]}
    >
      <div
        style={{ display: "flex", gap: "15px", flexDirection: "column" }}
      >

        <div>
          <span>Chave PIX:</span>
          <Input
            placeholder="Chave pix"
            onChange={(e) => setMessage(e?.target?.value)}
            value={message}
            defaultValue={message}

          />
        </div>

        <div>
          <span>Título do PIX:</span>
          <Input
            placeholder="Ex: Nome completo do titular"
            onChange={(e) => setPixTitulo(e?.target?.value)}
            value={pixTitulo}
            defaultValue={pixTitulo}

          />
        </div>

        <div>
          <Radio.Group
            onChange={(e) => setPixType(e?.target?.value)}
            value={pixType}
          >
            <span style={{ display: "flex", fontSize: ".9rem", marginBottom: "5px" }}>Qual o tipo da chave PIX?</span>
            <Radio value="CPF">CPF</Radio>
            <Radio value="CNPJ">CNPJ</Radio>
            <Radio value="PHONE">TELEFONE</Radio>
            <Radio value="EMAIL">EMAIL</Radio>
            <Radio value="EVP">CHAVE ALEATÓRIA</Radio>
          </Radio.Group>
        </div>

      </div>
    </Modal>
  );
};

export default ModalMensagemPix;
